import script from "./size-guide-table.vue?vue&type=script&setup=true&lang=js"
export * from "./size-guide-table.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__